import { NumberishDate } from '../types/dev';

/**
 * Create a new Date from a Date instanced as number built so :
 * - `Number[0] to Number[4] ` Year
 * - `Number[5] to Number[6] ` Month (1-12) (index based on 1)
 * - `Number[7] to Number[8] ` Day (1-31)
 * @param date {@link NumberishDate}
 * @returns instance of {@link Date}
 */
export function createDateFromNumberishDate(date: NumberishDate | number): Date {
  if (!date) throw new Error('Invalid date provided');

  const parsedDate = date.toString();
  const year = parseInt(parsedDate.slice(0, 4));
  const month = parseInt(parsedDate.slice(4, 6)) - 1;
  const day = parseInt(parsedDate.slice(6, 8));

  return new Date(year, month, day);
}
